import { Directive, Renderer, ElementRef, OnInit, Input } from '@angular/core';

@Directive({
  selector: '[appFocusMe]'
})
export class FocusMeDirective implements OnInit {

  constructor(public renderer: Renderer, public elementRef: ElementRef) {}

  @Input() readyForFocus: boolean;

  // TODO figure out why this causes error: thoughtData = this.preSaveTasks(thoughtData); [on the field label]

  ngOnInit() {
    if (this.readyForFocus) {
      this.renderer.invokeElementMethod(this.elementRef.nativeElement, 'focus', []);
    }
  }

}



// WEBPACK FOOTER //
// C:/Users/Alec/Documents/dev/recog/recog/src/app/shared-module/widgets/focus-me/focus-me.directive.ts